export const html = {
  __html: `<style>
    html {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      background-color: white !important;
    }

    .root-cloudpay {
      background-color: white !important;
    }

    .AppHeader-container {
      display: none !important;
      margin-bottom: 2% !important;
    }

    .bodyInvoice {
      background-color: #000000 !important;
      margin: 48px auto;
      font-family: 'Roboto', sans-serif;
      text-align: center;
      color: black;
    }

    .mailContent {
      margin: 0 auto !important;
      background: #000000;
    }

    .imageHeader {
      width: 100%;
      padding: 48px 0 24px;
    }

    .imageHeader img {
      max-height: 80px;
    }

    .msgContainer {
      padding: 0 10% !important;
      text-align: center;

      .first-table-info {
        color: white;
      }

      .second-table-info {
        color: white;
      }
    }

    .tableHeaders {
      color: #6a7d88;
      border-bottom: 1px solid #ccc;
    }

    .ctaButtons {
      margin: 16px;
    }

    .leftContent {
      color: white;
      width: 75%;
    }

    .rightContent {
      width: 25%;
      color: white;
    }

    .planLabel,
    .discountDescription {
      padding: 8px 0;
      font-weight: bold;
      color: {{planLabel}};
    }

    .amountLabel,
    .discountPrice {
      color: {{amountLabel}};
      font-weight: bold;
      padding: 12px 0;
      text-align: right;
    }

    .discountDescription {
      padding-top: 4px;
      padding-bottom: 4px;
      padding-left: 15px;
      position: relative;
      font-weight: normal;
      bottom: 8px;
    }

    .root-cloudpay .App.Cloudpay .Footer {
      display: none;
    }

    .discountPrice {
      padding-top: 4px;
      padding-bottom: 4px;
      position: relative;
      bottom: 8px;
    }

    .cardInfo {
      font-size: 11px;
      color: #777777;
    }

    .invoice-currency {
      color: white;
    }

    .legal-disclaimer {
      color: white;
    }

    @media print {
      @page {
        color: black;
        size: A4 portrait;
      }

      @page :right {
        margin-right: 20%;
      }

      .msgContainer {
  
        .first-table-info {
          color: black;
        }

        .second-table-info {
          color: black;
        }
      }

      .tableHeaders {
        color: #ccc;
        border-bottom: 1px solid #ccc;
      }

      .planLabel,
      .discountDescription {
        padding: 8px 0;
        font-weight: bold;
        color: {{planLabel}};
      }

      .amountLabel,
      .discountPrice {
        color: {{amountLabel}};
        font-weight: bold;
        padding: 12px 0;
        text-align: right;
      }

      .discountDescription {
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 15px;
        position: relative;
        font-weight: normal;
        bottom: 8px;
      }

      .discountPrice {
        padding-top: 4px;
        padding-bottom: 4px;
        position: relative;
        bottom: 8px;
      }

      .cardInfo {
        font-size: 11px;
        color: #ccc;
      }

      .leftContent {
        color: black;
      }

      .rightContent {
        color: black;
      }

      .invoice-currency {
        color: black;
      }

      .legal-disclaimer {
        color: black;
      }
    }
  </style>
  <div class="mailContent">
    <div class="imageHeader">
      <img src={{clientLogo}} alt={{client}} />
    </div>
    <div class="msgContainer">
      <div style="padding: 24px 0 0;">
        <div style="padding: 16px; background-color:#000000;">
          <table class="first-table-info" width="100%" style="font-size: 12px; text-align: left;">
            <tbody>
              <tr>
                <td width="20%"><b>{{paymentMethodLabel}}:</b></td>
                <td width="30%">{{methodName}}</td>
                <td width="20%"><b>{{orderNumberLabel}}:</b></td>
                <td width="30%" style="word-break: break-all;">{{orderId}}</td>
              </tr>
              <tr>
                <td width="20%"><b>{{customerLabel}}:</b></td>
                <td width="30%">{{name}} {{lastName}}</td>
                <td width="20%"><b>{{transactionDateLabel}}:</b></td>
                <td width="30%">{{date}}</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td width="20%"><b>{{servicePeriodLabel}}:</b></td>
                <td width="30%">{{serviceDateFrom}} - {{serviceDateTo}} </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="padding: 13px; background-color:#000000;">
          <table class="second-table-info" width="100%" style="font-size: 12px; text-align: left;">
            <tbody>
              {{proratedProduct}}
              {{products}}
              {{discount}}
            </tbody>
            <tfoot>
              <tr>
                <td class="leftContent planLabel" style="border-top: 1px solid #ccc; padding-top: 8px;">TOTAL</td>
                <td class="rightContent amountLabel" style="border-top: 1px solid #ccc; padding-top: 8px; text-align: right">
                    {{amount}}
                </td>
              </tr>
            </tfoot>
          </table>
          <div class="invoice-currency" style="font-size: 12px; padding-top: 5px;">
            {{currencyForInvoice}}
          </div>
        </div>
      </div>
      <div style="margin-left: 20px; margin-right: 20px; margin-top: 20px; background-color: #fff">
        <div style="mso-line-height-rule: exactly; mso-text-raise: 11px; vertical-align: middle; background-color: #fff">
          <p style="margin-top: 0; margin-bottom: 20px; font-size: 14px; line-height: 21px; text-align: center; background-color: #fff;"
            lang="x-size-14">
            <span style="text-decoration: inherit; color: #1a1a1a; background-color: #fff">
                  {{helpCenterMessage}}
            </span>
            <br style="background-color: #fff" />
            <a style="text-decoration: underline; transition: opacity 0.1s ease-in; color: #51aac5; background-color: #fff"
              href="https://motorplay.tv">
              <span style="text-decoration: inherit; color: #1f1f1f; background-color: #fff">
                <u>
                    <strong style="background-color: #fff">{{helpCenterTittle}}</strong>
                </u>
              </span>
            </a>
          </p>
        </div>
      </div>
      <div>
          <p style="margin-top: 0; margin-bottom: 0; font-family: arial, sans-serif">
            <span style="text-decoration: inherit">
                <span class="legal-disclaimer" style="text-decoration: inherit;">
                    © {{copyright}}.
                </span>
            </span>
          </p>
        </div>
    </div>
  </div>`,
};
